module.exports = __webpack_public_path__ + "static/media/anthia-mazaraki.0a08404d.jpg";